module.exports = "/lmstools/fonts/vendor/@mdi/materialdesignicons-webfont.eot?5ce4e52cebe3533718e70f5023421345";